<template>
  <!--  产品明细报表-->
  <div class="inventoryTableBox">
<!--    <breadcrumb :routerList="[{to:'/yuce/sellOn_list',title:'市场预测'},{title:'库存明细报表'}]"/>-->
    <Breadtabsheader/>
    <div style="margin:20px">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="formInline" ref="formInline" label-width="110px"
                   class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">

              <el-form-item label="产品大类" prop="oneLid">
                <brselectlazy category="product_level" :v="formInline.oneLid"
                              v-model="formInline.oneLid"
                              :clearable="true"
                              style="width:100%"/>
              </el-form-item>
              <el-form-item label="产品编号" prop="prodcode">
                <el-input v-model.trim="formInline.prodcode" placeholder="" @keyup.enter.native="query"
                          maxlength="255" clearable></el-input>
              </el-form-item>
              <el-form-item label="产品名称" prop="promodel">
                <el-input v-model.trim="formInline.promodel" placeholder="" @keyup.enter.native="query"
                          maxlength="255" clearable></el-input>
              </el-form-item>

            </div>
            <div class="h-formBtnOut h-columnCenter">
              <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData('formInline')">重置</el-button>
            </div>
          </el-form>
        </div>
      </div>
      <div class="h-row inventoryTableTable">
        <div class="h-rowIn" style="width:100%;">
          <el-table
              ref="multipleTable"
              :data="tableData"
              stripe
              border
              max-height="450"
              style="width: 100%">
            <el-table-column
                type="index"
                fixed
                width="40"
                label="#">
            </el-table-column>
            <el-table-column
                prop="prodseries"
                :show-overflow-tooltip="true"
                min-width="180"
                align="left"
                label="产品大类">
            </el-table-column>
            <el-table-column
                prop="prodcode"
                :show-overflow-tooltip="true"
                min-width="180"
                label="产品编码">
            </el-table-column>
            <el-table-column
                prop="promodel"
                :show-overflow-tooltip="true"
                min-width="180"
                label="产品名称">
            </el-table-column>
            <el-table-column
                    prop="factory"
                    :show-overflow-tooltip="true"
                    min-width="100"
                    label="产地">
            </el-table-column>
            <el-table-column
                    prop="lgort"
                    :show-overflow-tooltip="true"
                    min-width="100"
                    label="库位">
            </el-table-column>
            <el-table-column
                prop="price"
                min-width="100"
                :show-overflow-tooltip="true"
                label="单价(元)">
              <template slot-scope="scope">
                <div v-if="scope.row.price == null || scope.row.price == undefined ">
                </div>
                <div style="text-align: right;" v-else >
                  {{parseFloat(scope.row.price).toFixed(2)||'0.00'}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="库存">
              <el-table-column
                  prop="num"
                  :show-overflow-tooltip="true"
                  width="60"
                  label="占用">
                <el-table-column prop="time" :show-overflow-tooltip="true" width="100" label="普通">
                  <template slot-scope="scope">
                    {{scope.row.occupyCount||0}}
                    <!-- <div class="mx" @click="lookDetailed(scope.row.occupyCount,'orderInventoryDialog',scope.row,'zhanYong')">
                      {{scope.row.occupyCount||0}}
                    </div> -->
                  </template>
                </el-table-column>
                <el-table-column prop="time" :show-overflow-tooltip="true" width="100" label="改制">
                  <!--                  <template slot-scope="scope">-->
                  <!--                    <div style="text-align: right;">-->
                  <!--                      {{parseFloat(scope.row.price).toFixed(2)}}-->
                  <!--                    </div>-->
                  <!--                  </template>-->
                </el-table-column>
              </el-table-column>
              <el-table-column prop="time" :show-overflow-tooltip="true" width="100" label="未占用">
                <el-table-column prop="time" :show-overflow-tooltip="true" width="100" label="普通">
                  <template slot-scope="scope">
                    <div style='text-align: right'>
                      {{scope.row.unOccupyCount||0}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="time" :show-overflow-tooltip="true" width="100" label="改制">
                  <template slot-scope="scope">
                    <!--                    <div style="text-align: right;">-->
                    <!--                      {{parseFloat(scope.row.price).toFixed(2)}}-->
                    <!--                    </div>-->
                  </template>
                </el-table-column>

              </el-table-column>
            </el-table-column>

            <el-table-column
                prop="num"
                :show-overflow-tooltip="true"
                min-width="100"
                label="在途数量">
              <template slot-scope="scope">
                <div class="mx" @click="lookDetailed(scope.row.roadCount,'wayNumberDialog',scope.row)">
                  {{scope.row.roadCount||0}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="num"
                :show-overflow-tooltip="true"
                min-width="100"
                label="订单数量">
              <template slot-scope="scope">
                <div class="mx" @click="lookDetailed(scope.row.orderCount,'orderInventoryDialog',scope.row,'dingDanShuLiang')">
                  {{scope.row.orderCount||0}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="sales"
                :show-overflow-tooltip="true"
                min-width="100"
                label="需采购数量">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{scope.row.needPurchaseCount||0}}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="h-tableB h-mrt30">
            <div class="h-tableBL">
              <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出
              </el-button>
            </div>
            <div class="h-pagination2 h-pageCenter">
              <pagination :page="formInline" @query="query"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 库存占用普通明细弹窗和订单数量明细弹窗-->
    <orderInventoryDialog ref="orderInventoryDialog" @dialogBoolHide="dialogBoolHide" :dialogFormVisible="orderInventoryDialog"
                     :prodcode="prodcode" :prodType="prodType" :factory="factory"
                     v-if="orderInventoryDialog"></orderInventoryDialog>
    <!-- 在途数量明细弹窗-->
    <wayNumberDialog ref="wayNumberDialog" @dialogBoolHide="dialogBoolHide" :dialogFormVisible="wayNumberDialog"
                     :prodcode="prodcode" :factory="factory"
                     v-if="wayNumberDialog"></wayNumberDialog>

  </div>
</template>
<script>

  import ss from '../../../../api/SystemService';
  import updownfile from '../../../../utils/updownfile';
  import orderInventoryDialog from './orderInventoryDialog'; //库存占用普通明细弹窗
  import wayNumberDialog from './wayNumberDialog'; //在途数量明细弹窗


  export default {
    name: 'inventoryTable',
    data() {
      return {
        prodcode: '',//产品编码
        factory: '',//产地
        formInline: {
          oneLid: '',//产品大类
          prodcode: '',//产品编码
          productName: '',//产品名称
          idlist: [],
          pageSize: 10,
          pageNo: 1,
          total: 0,
        },
        opt: [],
        tableData: [],
        multipleSelection: [],
        showArea: true,
        prodType:'',//打开弹窗类型  zhanYong:占用普通明细  dingDanShuLiang:单数量明细弹窗
        orderInventoryDialog: false,//库存占用明细弹窗和订单数量明细弹窗
        wayNumberDialog: false,//在途数量明细弹窗
      }
    },

    created() {
      this.query();
    },
    components: {
      orderInventoryDialog,
      wayNumberDialog,
    },
    methods: {
      //关闭遮罩层
      dialogBoolHide(val) {
        this[val] = false
      },
      //查看明细
      lookDetailed(value, type, row,prodType) {
        // if(!value || value == 0) return
        this.prodcode = row.prodcode;
        this.factory = row.factory;
        if(prodType){
          this.prodType = prodType;
        }
        this[type] = true;
      },
      // 重置按钮
      resetData(formInline) {
        this.$refs[formInline].resetFields();
        this.query();
      },
      //明细导出
      exportExcel() {
        // var idlist=[];
        // this.multipleSelection.forEach(element => {
        //     idlist.push(element.id);
        // });
        this.formInline.idlist = [];
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach(element => {
            this.formInline.idlist.push(element.id);
          });
        }
        // /api/swyl/v1/report/oemStock/downloadExcel
        updownfile.down("/api/swyl/v1/report/oemStock/downloadExcel", this.formInline, "post", 'data');
      },
      //主数据获取
      query() {
        ss.inventory.selectPage(this.formInline).then(rd => {
          this.formInline.total = rd.total;
          this.tableData = rd.records;
        })
      },
    }
  }
</script>
<style scoped lang="css">
  .mx {
    color: #57aefe;
    cursor: pointer;
    text-align: right;
  }

</style>
<style>
  .inventoryTableTable .el-table thead.is-group th {
    background-color: #57aefe;
  }

  .inventoryTableTable .el-table tbody td, .inventoryTableTable .el-table .cell {
    text-align: left;
  }

  .inventoryTableTable .el-table th .cell {
    text-align: center;
  }
</style>

<style scoped>
  /*<!--//弹窗样式开始-->*/
  /deep/ .el-table .cell {
    text-align: left;
  }

  /deep/ .el-table th .cell {
    text-align: center;
  }

  /deep/ .el-form--inline .el-form-item__label {
    float: left;
  }

  /deep/ .el-date-editor .el-range-separator {
    padding: 3px 0px;
  }

  /deep/ .el-dialog__header {
    background-color: #57aefe;
  }

  /deep/ .el-dialog__header span {
    line-height: 0.3rem;
    color: #fff;
    font-weight: bold;
    font-size: 0.2rem;
  }

  /deep/ .el-dialog__headerbtn {
    top: 6px
  }

  /deep/ .el-dialog__close {
    height: 0.46rem;
    width: 0.46rem;
    line-height: 0.46rem;
    text-align: center;
    background-color: #fff;
    color: #015ba0;
    border-radius: 100%;
    font-size: 0.34rem;
    margin-top: 0.05rem;
  }
  /*<!--//弹窗样式结束-->*/
</style>
